import SlideShow from "../Reusable Elements/SlideShow";
import { materialsImages } from "../../data/slideShowData";

const Materials = () => {
    return (
        <div>
            <div className="bg-primary-blue text-primary-gold text-5xl font-poppins font-extralight text-center flex items-center justify-center pt-7">
                Our Process
            </div>
            <div className="flex w-screen items-center justify-between sm:flex-row pt-7 sm:pb-7 flex-col-reverse bg-primary-blue">
                <div>
                    <SlideShow side={"left"} images={materialsImages} />
                </div>
                <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2 items-center gap-y-12 mb-10 sm:mb-0">
                    <div className="w-fit flex items-center flex-col">
                        <div className="font-poppins font-extralight text-4xl text-center text-primary-gold sm:pt-0 pt-5">
                            Materials
                        </div>
                        <div className="font-poppins text-lg font-extralight text-center mt-1 text-primary-white px-10 sm:px-0">
                            We source only the finest, sustainably produced
                            materials, partnering with trusted local suppliers
                            to support regional craftsmanship. <br></br><br></br>By
                            prioritizing high luxury quality and conscious
                            sustainability, Sultana Homes offers exceptional
                            value without compromise, ensuring that every
                            project benefits from the strength of Pakistani
                            expertise.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Materials;
